export default "__VITE_ASSET__BNF0h5TO__"